"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initSDK = exports.ethereumMethods = exports.ethereumEvents = void 0;
var _snetSdkWeb = _interopRequireDefault(require("snet-sdk-web"));
var _web = _interopRequireDefault(require("web3"));
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EXPECTED_ID_ETHEREUM_NETWORK = Number(process.env.REACT_APP_ETH_NETWORK);
const ethereumMethods = exports.ethereumMethods = {
  REQUEST_ACCOUNTS: "eth_requestAccounts",
  REQUEST_CHAIN_ID: "eth_chainId",
  REQUEST_SWITCH_CHAIN: "wallet_switchEthereumChain"
};
const ethereumEvents = exports.ethereumEvents = {
  CHAIN_CHANGED: "chainChanged"
};
const DEFAULT_GAS_LIMIT = undefined;
const DEFAULT_GAS_PRICE = undefined;
const ON_ACCOUNT_CHANGE = "accountsChanged";
const ON_NETWORK_CHANGE = "chainChanged";
const detectEthereumNetwork = async () => {
  const chainIdHex = await web3Provider.request({
    method: ethereumMethods.REQUEST_CHAIN_ID,
    params: []
  });
  const networkId = parseInt(chainIdHex);
  return networkId;
};
const isUserAtExpectedEthereumNetwork = async () => {
  const currentNetworkId = await detectEthereumNetwork();
  return Number(currentNetworkId) === EXPECTED_ID_ETHEREUM_NETWORK;
};
const switchNetwork = async () => {
  const web3 = new _web.default(web3Provider);
  const hexifiedChainId = web3.utils.toHex(EXPECTED_ID_ETHEREUM_NETWORK);
  await web3Provider.request({
    method: ethereumMethods.REQUEST_SWITCH_CHAIN,
    params: [{
      chainId: hexifiedChainId
    }]
  });
};
let web3Provider;
let sdk;
const updateSDK = async () => {
  const isExpectedNetwork = await isUserAtExpectedEthereumNetwork();
  if (!isExpectedNetwork) {
    await switchNetwork();
  }
  const config = {
    networkId: await detectEthereumNetwork(),
    web3Provider,
    defaultGasLimit: DEFAULT_GAS_LIMIT,
    defaultGasPrice: DEFAULT_GAS_PRICE,
    rpcEndpoint: process.env.REACT_APP_WEB3_PROVIDER,
    tokenName: process.env.REACT_APP_TOKEN_NAME,
    standType: process.env.REACT_APP_STAND
  };
  sdk = new _snetSdkWeb.default(config);
  await sdk.setupAccount();
};
const defineWeb3Provider = () => {
  if ((0, _lodash.isUndefined)(window.ethereum)) {
    throw new Error("Metamask is not found");
  }
  web3Provider = window.ethereum;
};
const initSDK = async () => {
  try {
    defineWeb3Provider();
    await web3Provider.enable();
    await web3Provider.request({
      method: ethereumMethods.REQUEST_ACCOUNTS
    });
    // eslint-disable-next-line require-atomic-updates
    web3Provider.addListener(ON_ACCOUNT_CHANGE, accounts => {
      const event = new CustomEvent("snetMMAccountChanged", {
        detail: {
          address: accounts[0]
        }
      });
      window.dispatchEvent(event);
    });
    web3Provider.addListener(ON_NETWORK_CHANGE, network => {
      switchNetwork();
      const event = new CustomEvent("snetMMNetworkChanged", {
        detail: {
          network
        }
      });
      window.dispatchEvent(event);
    });
    await updateSDK();
    return sdk;
  } catch (error) {
    throw error;
  }
};
exports.initSDK = initSDK;